import React, {useImperativeHandle, useRef} from "react";
import {DICT_KEY, getDictNameByCode} from "../../../utils/constants";
import {useModel} from "../../../models";

const borderStyle = {
    border: "1px double #000",
}
const PrintTitle = () => {
    return (
        <h3 style={{
            textAlign: "center",
            fontSize: "18pt",
            fontFamily: "楷体,楷体_GB2312",
        }}>
            销售退货单
        </h3>
    )
};
const PrintHeader = ({
                         params: {
                             returnCode,
                             customerId,
                         }
                     }) => {
    return (
        <div style={{display: "flex"}}>
            <div style={{
                flex: "1",
                textAlign: "left"
            }}>
                销售退货单号:<span style={{marginLeft: "12px"}}>{returnCode}</span>
            </div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}
            >
                客户名称:
                <span style={{marginLeft: "12px"}}>
                    {getDictNameByCode(DICT_KEY.CM_DICT.CUSTOMER, customerId)}
                </span>
            </div>
        </div>
    )
}
const TableTotal = ({
                        params: {
                            discount,
                            returnTotalNum,
                            payableAmount
                        }
                    }) => {
    return (
        <div style={{display: "flex"}}>
            <div style={{
                flex: "1",
                textAlign: "left"
            }}>
                整单折扣:<span style={{marginLeft: "12px"}}>{discount}%</span>
            </div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}
            >
                退货总数量:<span style={{marginLeft: "12px"}}> {returnTotalNum}</span>
            </div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}
            >
                应付金额: <span style={{marginLeft: "12px"}}>{payableAmount}</span>
            </div>
        </div>
    )
}
const PrintFooter = ({
                         params: {
                             createUser,
                             operator
                         }
                     }) => {
    return (
        <div style={{display: "flex"}}>
            <div style={{
                flex: "2",
                textAlign: "left"
            }}>
                经办人:<span style={{marginLeft: "12px"}}>{createUser}</span>
            </div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}>
                操作员:<span style={{marginLeft: "12px"}}>{operator}</span>
            </div>
        </div>
    )
}

const PrintTable = ({
                        params: {
                            mappedList,
                            discount,
                            returnTotalNum,
                            payableAmount,
                        }
                    }) => {


    return (
        <table
            border="0"
            align="center"
            style={{
                borderCollapse: "collapse",
            }}
            width="100%"
        >
            <thead style={{display: "table-header-group",}}>
            {/*<tr>
                <td colSpan={6}>

                </td>
            </tr>*/}
            <tr>
                <th style={borderStyle}>配件编码</th>
                <th style={borderStyle}>配件名称</th>
                <th style={borderStyle}>图号</th>
                <th style={borderStyle}>数量</th>
                <th style={borderStyle}>含税单价</th>
                <th style={borderStyle}>含税金额</th>
            </tr>
            </thead>
            <tbody>
            {
                mappedList.map(el => (
                    <tr key={el.id}>
                        <td style={borderStyle}>{el.materialCode}</td>
                        <td style={borderStyle}>{el.materialName}</td>
                        <td style={borderStyle}>{el.replaceNum}</td>
                        <td style={borderStyle}>{el.returnNum}</td>
                        <td style={borderStyle}>{el.avgPrince}</td>
                        <td style={borderStyle}>{el.amount}</td>
                    </tr>))
            }
            <tr>
                <td style={borderStyle} colSpan={6}>
                    <TableTotal params={{
                        discount,
                        returnTotalNum,
                        payableAmount,
                    }}/>
                </td>
            </tr>
            </tbody>
            {/*<tfoot>
            <tr>
                <td colSpan={6}>

                </td>
            </tr>
            </tfoot>*/}
        </table>
    )
}


export default ({printRef}) => {
    const ref = useRef();
    useImperativeHandle(printRef, () => ({
        dom: () => {
            return ref.current;
        },
    }));


    const [{userInfo: {userName}}] = useModel("global");
    const [{
        selectedDocument: {
            createTime,
            createUser,
        },
        documentMaterialList,
        detailStatistics: {returnTotalNum},
        formData: {
            returnCode,
            customerId,
            discount = 100,
            payableAmount = 0,
            returnDesc,
        },
    },] = useModel("saleRo");

    const mappedList = documentMaterialList.map(el => {
        //平均价
        let avgPrince = el.payableAmount / el.returnNum;
        if (!!!avgPrince) {
            avgPrince = 0
        }
        //四舍五入
        avgPrince = avgPrince.toFixed(2);
        const amount = (avgPrince * el.returnNum).toFixed(2);

        // //上进位
        // avgPrince = (Math.ceil(avgPrince * 100) / 100).toFixed(2);
        // const amount = (Math.ceil(avgPrince * el.saleNum * 100) / 100).toFixed(2);

        return {
            ...el,
            avgPrince,
            amount
        };
    });
    return (
        <div ref={ref} hidden={true}>
            <div style={{width: "800px", margin: "0 auto"}}>
                <PrintTitle/>
                <PrintHeader params={{
                    returnCode,
                    customerId,
                }}/>
                <PrintTable params={{
                    mappedList,
                    discount,
                    returnTotalNum,
                    payableAmount,
                }}/>
                <PrintFooter params={{createUser, operator: userName}}/>
            </div>
        </div>
    )
}